// extracted by mini-css-extract-plugin
export default {"navbar":"navbar__aoC5e","buttons":"buttons__-bMcB"};